module.exports = __webpack_public_path__ + "img/Solar-Space_symbol_3.424428eb.png";